import React, { Suspense } from "react";

import type { ChatMessageListProps } from "./ChatMessageListInner";

const LazyChatMessageList = React.lazy(() =>
  import("./ChatMessageListInner").then((mod) => ({
    default: mod.ChatMessageList,
  })),
);

export const ChatMessageList = (props: ChatMessageListProps) => {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-0 min-w-0 flex-1 items-center justify-center p-4 text-sm text-slate-500">
          Loading messages…
        </div>
      }
    >
      <LazyChatMessageList {...props} />
    </Suspense>
  );
};

export type { ChatMessageListProps } from "./ChatMessageListInner";
